
import { useMemo } from 'react'
import concat from 'lodash/concat'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useGetUsers } from '../../../../api/users'
import { userTypeName } from './helpers'

dayjs.extend(utc)

export const useUsersCSVData = ({ data, columns }) => {
  return useMemo(() => {
    if (!data) return []
    const labels = columns.map(({ Header }) => Header)
    const rows = data.map(({ firstName, lastName, email, userTypeId, internal }) => {
      return [
        firstName || '',
        lastName || '',
        email || '',
        userTypeName(userTypeId, internal)
      ]
    })
    return concat([labels], rows)
  }, [data, columns])
}

const getSearch = (searchText, tableMode) => {
  if (tableMode !== 'client') return searchText
  return ''
}

const textSearchFields = ['firstName', 'lastName', 'email']

const getSortParams = (sort) => {
  if (sort && sort[0]) {
    return {
      orderBy: sort[0].id,
      orderDirection: sort[0].desc ? 'DESC' : 'ASC'
    }
  }
  return {}
}

const getSearchParams = (searchText) => {
  if (!searchText) return {}
  return { searchFields: textSearchFields, searchText }
}

export const useSearchUsers = ({
  pageIndex,
  pageSize,
  sort,
  searchText,
  tableMode
}) => {
  const search = useMemo(() => getSearch(searchText, tableMode), [searchText, tableMode])
  const query = useMemo(() => ({
    limit: pageSize,
    offset: pageIndex * pageSize,
    ...getSortParams(sort),
    ...getSearchParams(search)
  }), [pageSize, pageIndex, sort, search])

  const { data = {}, isLoading } = useGetUsers(query)

  return {
    data: isLoading ? [] : data.users,
    loading: isLoading,
    count: isLoading ? 0 : data.count
  }
}
